import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { PdpSharedDetailShipsFrom_item } from './__generated__/PdpSharedDetailShipsFrom_item.graphql';
// styles
import styles from './PdpSharedDetail.scss';

type Props = {
    item: PdpSharedDetailShipsFrom_item;
};

const PdpSharedDetailShipsFromComponent: FC<Props> = props => {
    const itemAddress = props?.item?.address?.itemAddress;
    return itemAddress ? (
        <div className={styles.shipsFromDetail}>
            <span className={styles.title}>
                <FormattedMessage
                    id="pdp.pdpShippingDetails.shipsFrom"
                    defaultMessage="Ships From:"
                />
            </span>{' '}
            <span className={styles.content}>{itemAddress}</span>
        </div>
    ) : null;
};

export const PdpSharedDetailShipsFrom = createFragmentContainer(PdpSharedDetailShipsFromComponent, {
    item: graphql`
        fragment PdpSharedDetailShipsFrom_item on Item {
            address {
                itemAddress: displayCityStateCountry(fullCountryName: true)
            }
        }
    `,
});
